module.exports = __webpack_public_path__ + "static/media/team1.69938ca5.jpg";